import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Avatar,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Select,
} from "@mui/material";
// components
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate } from "react-router-dom";
import axios from "axios";
// import LeagueDialog from "src/components/leagues-admin/LeagueDialog";
// import DeleteDialog from "../components/leagues-admin/DeleteDialog";
import RulesDialog from "../components/pickem-admin/RulesDialog";
import PageDialog from "../components/pickem-admin/PageDialog";
import DeleteDialog from "../components/pickem-admin/DeleteDialog";
// ----------------------------------------------------------------------
export default function PagesList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  const [openPageDialog, setOpenPageDialog] = useState(false);
  const [showDeletePageDialog, setShowDeletePageDialog] = useState(false);

  const [editPage, setEditPage] = useState(null);
  const [lang, setLang] = useState("en");
  const [deletePage, setDeletePage] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pages`)
      .then(function (response) {
        setRows(response.data.pages.filter((item) => item !== null));
      });
  }, []);
  const deletePageHandler = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_BASE_URL}/admin/pages/${id}`)
      .then(function (response) {
        setDeletePage(null);
        window.location.reload(false);
      });
  };
  const successPageHandler = (page) => {
    if (page?.page_id) {
      axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pages/${page.page_id}`,
          { ...page }
        )
        .then(function (response) {
          window.location.reload(false);
        });
    } else {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/admin/pages`, { ...page })
        .then(function (response) {
          window.location.reload(false);
        });
    }
    setOpenPageDialog(false);
  };

  const closePageDialog = () => {
    setEditPage(null);
    setOpenPageDialog(false);
  };
  const openAddPageDialog = () => {
    setEditPage(null);
    setOpenPageDialog(true);
  };
  const openEditPageDialog = (index) => {
    const page = rows[index];
    setEditPage(page);
    setOpenPageDialog(true);
  };

  const handleChangeSelect = (e) => {
    setLang(e.target.value);
  };

  const openDeletePageDialog = (index) => {
    const page = rows[index];
    setDeletePage(page.page_id);
    setShowDeletePageDialog(true);
  };
  return (
    <>
      <Helmet>
        <title>Pages</title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Pages and Rules
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => openAddPageDialog()}
          >
            New Page
          </Button>
        </Stack>

        <Card>
          {rows === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Route</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.page_key ?? ""}
                        </TableCell>

                        <TableCell component="th" scope="row">
                          <Button
                            variant="outlined"
                            onClick={() =>
                              navigate(
                                `/dashboard/pages/edit?page_id=${row.page_id}`
                              )
                            }
                            startIcon={<Iconify icon="eva:edit-outline" />}
                            sx={{ mr: 2 }}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => openDeletePageDialog(index)}
                            startIcon={<Iconify icon="eva:trash-2-outline" />}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
      <PageDialog
        page={editPage}
        open={openPageDialog}
        onSuccessHandler={successPageHandler}
        onClose={closePageDialog}
      />
      <DeleteDialog
        openConfirm={showDeletePageDialog}
        setOpenConfirm={setShowDeletePageDialog}
        deleteGameHandler={deletePageHandler}
        questionIndex={deletePage}
        type={"page"}
      />
    </>
  );
}
